module.exports = __webpack_public_path__ + "img/volunteers.7dcf0675.svg";